import React, { useCallback, useEffect } from 'react';
import { FormContext, useForm } from 'react-hook-form';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FileManager from 'UI/components/organisms/FileManager';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { Endpoints } from 'UI/constants/endpoints';

import { QuickEntryTextField } from '../QuickEntryTextField';

import {
  COPIES,
  DEFAULT_FORM_VALUES,
  DELETE_API_VERSION,
  FORM_FIELDS,
  UPLOAD_CATEGORIES
} from './JobOrderQuickEntryDrawer.constants';
import { useStyles } from './JobOrderQuickEntryDrawer.styled';

export const JobOrderQuickEntryDrawer = ({ onClose = () => {}, notesTemplate = null }) => {
  const classes = useStyles();
  const shouldUseNotesTemplate = typeof notesTemplate === 'string' && notesTemplate.trim();
  const form = useForm({
    defaultValues: {
      ...DEFAULT_FORM_VALUES,
      ...(shouldUseNotesTemplate ? { [FORM_FIELDS.notes]: notesTemplate } : {})
    },
    mode: 'onSubmit',
    reValidateMode: 'onBlur'
  });
  const { handleSubmit, register, setValue } = form;

  useEffect(() => {
    register({ name: FORM_FIELDS.files });
  }, [register]);

  const handleFilesChanged = useCallback(
    data => {
      const attachmentsChanged = flatMap(map(data, 'files'));

      setValue(FORM_FIELDS.files, attachmentsChanged);
    },
    [setValue]
  );

  const handleValidSubmit = handleSubmit(onClose);

  const buttonDefinitions = [
    {
      props: {
        text: COPIES.actions.cancel,
        variant: 'text',
        onClick: onClose
      }
    },
    {
      props: {
        text: COPIES.actions.saveEntry,
        variant: 'outlined',
        onClick: handleValidSubmit
      }
    },
    {
      props: {
        text: COPIES.actions.continueToDataSheet,
        variant: 'contained',
        onClick: handleValidSubmit
      }
    }
  ];

  return (
    <FPDrawer
      CardHeaderProps={{ title: COPIES.title }}
      FPDrawerProps={{
        open: true,
        onClose,
        classes: { paper: classes.drawerPaper }
      }}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
      hasPaddingContent={false}
      onClose={onClose}
    >
      <FormContext {...form}>
        <div className={classes.content}>
          <QuickEntryTextField
            label={COPIES.fields.position}
            name={FORM_FIELDS.position}
            required
            rows={1}
          />
          <QuickEntryTextField
            label={COPIES.fields.hiringAuthorityName}
            name={FORM_FIELDS.hiringAuthorityName}
            rows={1}
          />
          <QuickEntryTextField
            label={COPIES.fields.companyName}
            name={FORM_FIELDS.companyName}
            rows={1}
          />
          <QuickEntryTextField
            label={COPIES.fields.notes}
            multiline
            name={FORM_FIELDS.notes}
            rows={12}
          />
          <div className={classes.uploads}>
            <FileManager
              apiVersionForDeleting={DELETE_API_VERSION}
              defaultCategories={UPLOAD_CATEGORIES}
              filesEndpoint={Endpoints.Files}
              isNewEntity
              layoutInColumns
              module="quickEntryJobOrder"
              onAttachmentsChanged={handleFilesChanged}
              showItemDate
              showItemMenu
              viewItemOnClick
            />
          </div>
        </div>
      </FormContext>
    </FPDrawer>
  );
};
